import type { Block, BlockAverageData, Content } from './types';

type BlockAverage = {
  id: string;
  average: number | null;
  contents: Array<Content>;
};

export const getAveragesFromClassroomBlockAverages = (
  classroomBlockAverages: BlockAverage[]
): BlockAverageData[] => {
  if (!classroomBlockAverages) return [];

  return classroomBlockAverages.map((block) => ({
    id: block.id,
    average: block.average,
  }));
};

export const getAveragesFromStudentBlocks = (
  studentBlocks: Block[]
): BlockAverageData[] => {
  if (!studentBlocks) return [];

  return studentBlocks
    .filter((block): block is Block => Boolean(block.blockId))
    .map((block) => ({
      id: block.blockId!,
      average: block.score ?? null,
      blockTitle: block.blockTitle,
    }));
};
